import { State } from 'interfaces/state'
import { createSelector } from 'reselect'

export const subscriptionSelector = (state: State) =>
  state.data.subscription

export const subscriptionInfoSelector = createSelector(
  subscriptionSelector,
  (subscription) => subscription.info
)

export const subscriptionCanBeCancelledSelector = (state: State): boolean =>
  Boolean(subscriptionInfoSelector(state).data?.can_be_cancelled)
